import React from 'react';
import { endpoints } from '../api';
import { useNavigate } from 'react-router-dom';

const Selection = () => {
    const navigate = useNavigate();
    const sel = async (idx) => {
        await endpoints.selectVersion({
            user_email: localStorage.getItem('user_email'),
            campaign_name: localStorage.getItem('active_campaign'),
            subject_index: idx, body_index: idx
        });
        navigate('/schedule');
    };
    return (
        <div className="card">
            <h2>Select Version</h2>
            {[0, 1, 2].map(i => <button key={i} className="btn" style={{margin:'10px 0'}} onClick={() => sel(i)}>Select Option {i+1}</button>)}
        </div>
    );
};
export default Selection;